// component

import { IRecommandCreatorDB } from 'type/wconcepdb';

import TableCell from 'components/common/table/cell/TableCell';
import CorePictureAvatar from 'shared/avatar/CorePictureAvatar';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import CoreTag from 'shared/tag/CoreTag';
import { EllipsisText } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
// utils
import { setCategoryColor } from 'utils/colorType';
import round, { floatFixed, roundFloat } from 'utils/round';
// type
import { recommend_header_arr } from 'utils/table';

const useRecommendTable = (platform: 'ig' | 'yt' = 'ig') => {
	/** cell_type이 number인 cell */
	const NumberCell = (value: number | null, unit: string, idx: number) => {
		const result = value === null ? '-' : `${round(value, 'round')} ${unit}`;
		return (
			<TableCell _width={recommend_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	/** cell_type이 percent인 cell */
	const percentCell = (value: number | null, idx: number) => {
		const result =
			value === null ? '-' : floatFixed(roundFloat(value, 'round', 2), 2) + '%';
		return (
			<TableCell _width={recommend_header_arr[idx].width} cell_type="number">
				{result}
			</TableCell>
		);
	};
	// 리턴할 객체
	const match_cell_mapper: Record<
		string,
		(data: IRecommandCreatorDB, idx: number) => JSX.Element
	> = {
		profile: (data, idx) => (
			<TableCell _width={recommend_header_arr[idx].width}>
				<Grid flex="start" _gap="16px" _padding="0 0 0 16px">
					<CoreSvg>{platform === 'ig' ? <Icon.Insta /> : <Icon.Youtube />}</CoreSvg>
					<CorePictureAvatar
						size={'default'}
						color_type={'blue'}
						text={data?.username}
						picture={data?.profileImage}
					/>
					<Grid flex="start" direction="column" align_items="start">
						<Grid _width="100%" flex="start" _gap="8px">
							<EllipsisText typo="p_bold">{data?.username}</EllipsisText>
						</Grid>
						<EllipsisText _width="100%" typo="span">
							{data?.biography}
						</EllipsisText>
					</Grid>
				</Grid>
			</TableCell>
		),
		link: (data, idx) => (
			<TableCell _width={recommend_header_arr[idx].width} cell_type="number">
				<a
					href={data.link}
					target="_blank"
					onClick={(e) => {
						e.stopPropagation();
					}}
					rel="noreferrer"
				>
					<CoreSvg>
						<Icon.OutLink />
					</CoreSvg>
				</a>
			</TableCell>
		),
		category: (data, idx) => {
			return (
				<TableCell _width={recommend_header_arr[idx].width}>
					<Grid flex="start" _gap="8px">
						{data?.category1 && (
							<CoreTag
								tag_type="text"
								color_type={setCategoryColor(data?.category1)}
								value={data?.category1}
							/>
						)}
						{data?.category2 && (
							<CoreTag
								tag_type="text"
								color_type={setCategoryColor(data?.category2)}
								value={data?.category2}
							/>
						)}
					</Grid>
				</TableCell>
			);
		},
		follower_count: (data, idx) => <>{NumberCell(data?.followers, '명', idx)}</>,
		match_level: (data, idx) => (
			<TableCell _width={recommend_header_arr[idx].width} cell_type="center">
				<>
					{data?.matchingLevel?.toLowerCase() === 'mega' && `S등급/메가`}
					{data?.matchingLevel?.toLowerCase() === 'macro' && `A등급/매크로`}
					{data?.matchingLevel?.toLowerCase() === 'micro' && `B등급/마이크로`}
				</>
			</TableCell>
		),
		growth_rate: (data, idx) => (
			<TableCell _width={recommend_header_arr[idx].width} cell_type="number">
				{`${data?.viewCountGrowthRate.toFixed(1)}%`}
			</TableCell>
		),
		audience: (data, idx) => (
			<TableCell _width={recommend_header_arr[idx].width} cell_type="number">
				<Text typo="span">{`${data?.audience.ageGroup} ${
					data?.audience.gender === 'F' ? '여성' : '남성'
				}(${data?.audience.percentage}%)`}</Text>
			</TableCell>
		),
		fashion_contents: (data, idx) => <></>,
		collaboration: (data, idx) => <></>, // State를 보고 있어야함으로 SearchResult에서 처리
	};

	return match_cell_mapper;
};

const { Grid, Text } = style;

export default useRecommendTable;
